
import Vue from "vue";
import {CustomViewTab} from "@/utils/tabs/custom-view-tab";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => CustomViewTab,
			required: true
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		save(){
			this.$emit("save");
		}
	},
	components: {},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
